import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Download, Upload, ArrowLeftRight, PieChart, TrendingUp, ExternalLink, MoreVertical } from 'lucide-react';
interface DropdownOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}
interface DropdownProps {
  value: string;
  options: DropdownOption[];
  onChange: (value: string) => void;
  showLearnMore?: boolean;
  onLearnMore?: () => void;
  className?: string;
  variant?: 'default' | 'actions' | 'inline';
}
export function Dropdown({
  value,
  options,
  onChange,
  showLearnMore = false,
  onLearnMore,
  className = '',
  variant = 'default'
}: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleSelect = (optionValue: string) => {
    onChange(optionValue);
    setIsOpen(false);
  };
  const selectedOption = options.find(opt => opt.value === value);
  return <div className={`relative ${className}`} data-id="element-1797">
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center gap-2 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-purple focus:ring-offset-2 focus:ring-offset-background-primary ${variant === 'actions' ? 'p-1 hover:bg-background-elevated rounded' : variant === 'inline' ? 'font-mono text-sm text-text-secondary hover:text-text-primary' : 'px-4 py-2 bg-background-secondary rounded-lg hover:bg-background-elevated'}`} data-id="element-1798">
        {variant === 'actions' ? <MoreVertical size={16} className="text-text-secondary" data-id="element-1799" /> : variant === 'inline' ? <>
            <span data-id="element-1800">{selectedOption?.label || value}</span>
            <ChevronDown size={14} className="text-text-secondary" data-id="element-1801" />
          </> : <>
            <span className="text-sm font-medium text-text-primary" data-id="element-1802">
              {selectedOption?.label || value}
            </span>
            {isOpen ? <ChevronUp size={16} className="text-text-secondary" data-id="element-1803" /> : <ChevronDown size={16} className="text-text-secondary" data-id="element-1804" />}
          </>}
      </button>

      {isOpen && <>
          {/* Backdrop to close dropdown when clicking outside */}
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} data-id="element-1805" />

          <div className={`absolute right-0 top-full mt-2 bg-background-elevated border border-border-subtle rounded-xl shadow-lg p-1 z-20 ${variant === 'inline' ? 'min-w-[80px]' : 'min-w-[200px]'}`} data-id="element-1806">
            {options.map(option => <button key={option.value} onClick={() => handleSelect(option.value)} className={`
                  w-full px-3 py-2 text-left text-sm font-medium transition-all flex items-center gap-3 rounded-md
                  ${option.value === value ? 'text-[#A78BFA] bg-white/[0.08]' : 'text-text-primary hover:bg-white/[0.06] hover:text-white'}
                `} data-id="element-1807">
                {option.icon && <span className="text-text-secondary" data-id="element-1808">{option.icon}</span>}
                {option.label}
              </button>)}

            {showLearnMore && <>
                <div className="border-t border-border-subtle my-1" data-id="element-1809" />
                <button onClick={() => {
            onLearnMore?.();
            setIsOpen(false);
          }} className="w-full px-3 py-2 text-left text-sm font-medium text-text-primary hover:bg-background-secondary hover:text-white transition-colors flex items-center gap-2 rounded-md" data-id="element-1810">
                  <ExternalLink size={14} data-id="element-1811" />
                  Learn more
                </button>
              </>}
          </div>
        </>}
    </div>;
}